import React from 'react'
import Counter1 from "../../../assets/images/counter-1.png"
import Counter2 from "../../../assets/images/counter-2.png"
import Counter3 from "../../../assets/images/counter-3.png"
import BallIcon from "../../../assets/images/ball.png"

const Counter = () => {
  return (
    <div>
      <div className="rs-counter counter-style blue-bg pt-120 pb-120 md-pt-80 md-pb-80">
				<div className="container">
					<div className="row">
						<div className="col-lg-4 col-md-6 md-mb-30">
							<div className="rs-counter-list">
								<div className="counter-text">
									<div className="counter-icon">
										<img src={Counter1} alt="Icons" />
									</div>
									<div className="counter-number">
	                                    <span className="rs-count">150</span>
	                                    <span className="prefix">+</span>
	                                    <h5 className="title">Services Provider</h5>
	                                </div>
								</div>
							</div>
						</div>
						<div className="col-lg-4 col-md-6 md-mb-30">
							<div className="rs-counter-list">
								<div className="counter-text">
									<div className="counter-icon">
										<img src={Counter2} alt="Icons"/>
									</div>
									<div className="counter-number">
	                                    <span className="rs-count">2000</span>
	                                    <span className="prefix">+</span>
	                                    <h5 className="title"> Order Served</h5>
	                                </div>
								</div>
							</div>
						</div>
						<div className="col-lg-4 col-md-6">
							<div className="rs-counter-list">
								<div className="counter-text">
									<div className="counter-icon">
										<img src={Counter3} alt="Icons" />
									</div>
									<div className="counter-number">
	                                    <span className="rs-count">1000</span>
	                                    <span className="prefix">+</span>
	                                    <h5 className="title">5 Star Received</h5>
	                                </div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="counter-animation">
					<div className="animate-ball one">
						<img className="scale" src={BallIcon} alt="Images" />
					</div>
					<div className="animate-ball two">
						<img className="rotated-style2" src={BallIcon} alt="Images" />
					</div>
					<div className="animate-ball three">
						<img className="rotated-style2" src={BallIcon} alt="Images" />
					</div>
					<div className="animate-ball four">
						<img className="scale" src={BallIcon} alt="Images" />
					</div>
					<div className="animate-ball five">
						<img className="rotated-style2" src={BallIcon} alt="Images" />
					</div>
					<div className="animate-ball six">
						<img className="scale" src={BallIcon} alt="Images" />
					</div>
				</div>
			</div>
    </div>
  )
}

export default Counter
